class HTTPStatusError extends Error {

  constructor(code, statusText, errorData = null) {
    super(code);
    this.errorCode = code;
    this.statusText = statusText;
    this.errorData = errorData;
    this.name = 'HTTPStatusError';
  }

}

export default HTTPStatusError;
